import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";

import "./styles/Global.css";
import "./styles/Header.css";
import "./styles/Footer.css";
import "./styles/Home.css";

import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </AuthProvider>
  </React.StrictMode>
);